import React from 'react';

import { Button } from '@interlayer/js/components/common/Button';

import { VIEWS as VIEWS_BUTTON } from '@interlayer/js/app/components/common/Button/constants';
import { useSwitchMobileMenu } from '@interlayer/js/app/components/main/DefaultHeader/components/HeaderMobile/hooks';
import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup/hooks';

import { TCombinationButtonsProps } from './types';

import style from '../MenuItem.scss';

export const CombinationButtons: React.FC<TCombinationButtonsProps> = ({ title, icon }) => {
    const showLoginPopup = useLoginPopup();
    const switchMobileMenu = useSwitchMobileMenu();
    const [dTagRegistrationURL = '/register'] = useDynamicTags([DYNAMIC_TAG_NAMES.registrationURL]);
    const [login, joinNow] = title.split('|');

    const handleShowLoginPopup = () => {
        switchMobileMenu(false);
        showLoginPopup();
    };

    return (
        <div className={clsx(style.linkContainer, style.btnContainer)}>
            {icon}

            {Boolean(login) && (
                <Button
                    view={VIEWS_BUTTON.link}
                    className={clsx(style.item, style.btn)}
                    onClick={handleShowLoginPopup}
                >
                    {login}
                </Button>
            )}

            {Boolean(joinNow) && (
                <>
                    {'|'}

                    <Button
                        href={dTagRegistrationURL}
                        view="link"
                        className={clsx(style.item, style.btn)}
                    >
                        {joinNow}
                    </Button>
                </>
            )}
        </div>
    );
};
